/* Memerle custom — scroll animations */
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.animate-on-scroll').forEach((el) => observer.observe(el));
}

/* Memerle — hauteur totale (sections au-dessus du header + .site-header) + offset top pour position:fixed */
function memerleGetTopOffsetBeforeHeader() {
  const headerSection = document.querySelector('#shopify-section-header');
  if (!headerSection) return 0;
  let top = 0;
  let el = headerSection.previousElementSibling;
  while (el) {
    top += el.offsetHeight;
    el = el.previousElementSibling;
  }
  return top;
}

function setMemerleHeaderStackHeight() {
  const wrapper = document.querySelector('#memerle-header-wrapper');
  document.documentElement.style.setProperty('--site-header-top', '0px');

  if (wrapper) {
    document.documentElement.style.setProperty('--header-height', `${wrapper.offsetHeight}px`);
    return;
  }

  const top = memerleGetTopOffsetBeforeHeader();
  const siteHeader = document.querySelector('.site-header');
  const siteH = siteHeader ? siteHeader.offsetHeight : 64;
  document.documentElement.style.setProperty('--header-height', `${top + siteH}px`);
}

window.setMemerleHeaderStackHeight = setMemerleHeaderStackHeight;

/* Memerle — Header scroll (classe .scrolled sur la barre verre) */
function memerleUpdateSiteHeaderScrolled() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  if (window.scrollY > 20) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setMemerleHeaderStackHeight();
  window.addEventListener('resize', setMemerleHeaderStackHeight, { passive: true });
  window.addEventListener('load', setMemerleHeaderStackHeight, { passive: true });
  window.addEventListener('scroll', memerleUpdateSiteHeaderScrolled, { passive: true });
  memerleUpdateSiteHeaderScrolled();
});
